(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('OwnerAssessmentController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'commonAricService', 'aricControls',
        '$rootScope', 'controlOwnerAssessment', 'ownerAssessmentTypes', 'attachmentService'];

    function Controller($scope, $state, $stateParams, commonAricService, aricControls,
                        $rootScope, controlOwnerAssessment, ownerAssessmentTypes, attachmentService) {

        $scope.ownerAssessmentType = $stateParams.OwnerAssessmentType;
        var typeIndx = ownerAssessmentTypes.indexOf($scope.ownerAssessmentType);

        $scope.ctrlCtxt = {
            needSaveChanges: false,
            isSubmitting: false,
            isUploading: false,
            hasAttachments: false,
            FileName: '',
            acceptedFiles: '*',
			isFraudPage: $scope.ownerAssessmentType === 'Fraud',
			isResponsibilityPage: $scope.ownerAssessmentType === 'Responsibility',
            isOperationalPage: $scope.ownerAssessmentType === 'Operational'
        };

        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        //Number of Validation Steps
        $scope.numSteps = aricControls.length + ownerAssessmentTypes.length;

        // Fetch Current OwnerAssessments
        $scope.controlOwnerAssessment = controlOwnerAssessment;

        // Fetch Certification Attachments
        getCertificationAttachments();

        // Get Progress Status
        $scope.getProgressCount = function () {
            if (!aricControls) return 0;

            var stepsValidated = _.filter(aricControls, {ControlAssessment: {IsCertificationInProgress: true}}).length;

            // To be improved to match real Owner Assessment step numbers
            if ($scope.controlOwnerAssessment.IsCertificationInProgress) {
                stepsValidated = stepsValidated + ownerAssessmentTypes.length;
            }

            return stepsValidated;
        };

        // Answer Question
        $scope.answerQuestion = function (property, answer) {

            if (!_.isUndefined(answer)) {
                $scope.controlOwnerAssessment[property] = answer;
            }

            $scope.pageIsDirty();
        };

        // Is Fraud Comment missing
        $scope.isFraudCommentMissing = function () {
            return $scope.controlOwnerAssessment.IsAwareOfFraudOrIllegalActs === true
                && !$scope.controlOwnerAssessment.FraudComment;
		};

		// Is Responsibility Comment missing
		$scope.isResponsibilityCommentMissing = function () {
			return $scope.controlOwnerAssessment.IsResponsibilityAccurate == 2
				&& !$scope.controlOwnerAssessment.ResponsibilityComment;
		};

        // Is Operational Comment missing
        $scope.isOperationalCommentMissing = function () {
            return $scope.controlOwnerAssessment.ReportedAllOperationalLosses === false
                && !$scope.controlOwnerAssessment.OperationalLossesComment;
        };

        // Show Save or Save and Continue Action?
        $scope.showSaveAndContinueAction = function () {
            if ($scope.showSubmitAction()) return false;
            if (!$scope.ctrlCtxt.needSaveChanges) return false;

            return $scope.form.$valid;
        };

        // Save And Continue
        $scope.saveAndContinue = function () {
            commonAricService
                .saveControlOwnerAssessment($scope.controlOwnerAssessment, $stateParams.ItemPersonID)
                .then(function (updatedAssessment) {
                    $scope.controlOwnerAssessment = updatedAssessment;
                    $scope.pageIsNotDirty();
                    $scope.goToNextStep();
                    getCertificationAttachments();
                });
        };

        // Show Submit Action
        $scope.showSubmitAction = function () {
            if (!aricControls) return false;
            if ($scope.showResetAction()) return false;

            var allControlsValidated = _.every(aricControls, {
                ControlAssessment: {IsCertificationInProgress: true}
            });

            return allControlsValidated && $scope.controlOwnerAssessment.IsCertificationInProgress;
        };

        // Delete the certification attachments
        $scope.deleteCertificationAttachments = function () {
            $scope.controlOwnerAssessment.AttachmentsExternalIDs = [];
            $scope.controlOwnerAssessment.AttachmentsIDs = [];
            $scope.controlOwnerAssessment.File = null;
            $scope.ctrlCtxt.hasAttachments = false;
            $scope.saveAndContinue();
        };

        // Get the certification attachments
        function getCertificationAttachments () {
            commonAricService
                .getCertificationAttachments($scope.controlOwnerAssessment.ControlOwnerAssessmentID)
                .then(function (attachments) {
                    if (attachments.length) {
                        $scope.ctrlCtxt.hasAttachments = true;
                        $scope.ctrlCtxt.FileName = attachments[0].FileName;
                    }
                });
        };

        // Upload attachment
        $scope.uploadCertificationAttachments = function (file) {
            attachmentService.uploadFile(file)
                .then(function (file) {
                    if (file.messageSeverity && file.messageSeverity === 'Error') {
                        $scope.controlOwnerAssessment.File = null;
                    } else {
                        $scope.controlOwnerAssessment.AttachmentsExternalIDs = [file.AttachmentExternalID];
                        $scope.controlOwnerAssessment.AttachmentsIDs = [file.AttachmentID];
                        $scope.pageIsDirty();
                    }
                }, function () {
                    $scope.controlOwnerAssessment.File = null;
                })
                .finally(function () {
                    $scope.ctrlCtxt.isUploading = false;
                });
        };

        // Submit
        $scope.submit = function () {
            if ($scope.ctrlCtxt.isSubmitting) return;

            $scope.ctrlCtxt.isSubmitting = true;
            commonAricService
                .submitControlCertification($scope.controlOwnerAssessment)
                .then(function () {
                    $state.go('aricCertification.user.completed');
                    $scope.pageIsNotDirty();
                })
                .finally(function () {
                    $scope.ctrlCtxt.isSubmitting = false;
                });
        };

        // Show Reset Action?
        $scope.showResetAction = function () {
            return $scope.ctrlCtxt.needSaveChanges;
        };

        // Discard Changes
        $scope.discardChanges = function () {
            $state.reload();
        };

        // Show Previous Control Action
        $scope.showPreviousStepAction = function () {
            return true;
        };

        // Go To Previous Control
        $scope.goToPreviousStep = function () {

            if (typeIndx === 0) {
                var prevIdx = aricControls.length - 1;
                $state.go('aricCertification.user.control',
                    {ControlID: aricControls[prevIdx].ControlID},
                    {reload: true});
                return;
            }

            $state.go('aricCertification.user.assessment',
                {OwnerAssessmentType: ownerAssessmentTypes[typeIndx - 1]});
        };

        // Show Next Control Action
        $scope.showNextStepAction = function () {
            return $scope.ownerAssessmentType !== ownerAssessmentTypes[ownerAssessmentTypes.length - 1];
        };

        // Go To Next Control
        $scope.goToNextStep = function () {
            if (!$scope.showNextStepAction()) return;

            $state.go('aricCertification.user.assessment',
                {OwnerAssessmentType: ownerAssessmentTypes[typeIndx + 1]});
        };
    }
})();
